import { getTrackingConsent } from "./trackingConsent";

const env = {
  analyticsEnabled: process.env.REACT_APP_ANALYTICS_ENABLED === "true",
  gaMeasurementId: process.env.REACT_APP_GA_MEASUREMENT_ID || "",
  clarityEnabled: process.env.REACT_APP_CLARITY_ENABLED === "true",
  clarityProjectId: process.env.REACT_APP_CLARITY_PROJECT_ID || "",
};

let analyticsInitialized = false;
let gaScriptLoaded = false;
let clarityScriptLoaded = false;
let lastTrackedPath = "";

const canTrack = () => env.analyticsEnabled && getTrackingConsent();

const appendScript = (id, src) => {
  if (typeof document === "undefined") return;
  if (document.getElementById(id)) return;
  const script = document.createElement("script");
  script.id = id;
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
};

const initGoogleAnalytics = () => {
  if (!env.gaMeasurementId || gaScriptLoaded || typeof window === "undefined") return;

  appendScript(
    "proshare-ga-script",
    `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(env.gaMeasurementId)}`
  );

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  window.gtag("js", new Date());
  window.gtag("config", env.gaMeasurementId, { send_page_view: false });
  gaScriptLoaded = true;
};

const initClarity = () => {
  if (!env.clarityEnabled || !env.clarityProjectId || clarityScriptLoaded || typeof window === "undefined") {
    return;
  }

  ((c, l, a, r, i, t, y) => {
    c[a] =
      c[a] ||
      function clarity() {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = `https://www.clarity.ms/tag/${i}`;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", env.clarityProjectId);

  clarityScriptLoaded = true;
};

export const initializeAnalytics = () => {
  if (analyticsInitialized || !canTrack()) return;
  initGoogleAnalytics();
  initClarity();
  analyticsInitialized = true;
};

export const trackPageView = ({ path, title }) => {
  if (!canTrack() || !path) return;
  initializeAnalytics();
  if (lastTrackedPath === path) return;
  lastTrackedPath = path;

  if (window.gtag && env.gaMeasurementId) {
    window.gtag("event", "page_view", {
      page_title: title || document.title,
      page_location: window.location.href,
      page_path: path,
    });
  }
};

export const trackEvent = (name, payload = {}) => {
  if (!canTrack() || !name) return;
  initializeAnalytics();

  if (window.gtag && env.gaMeasurementId) {
    window.gtag("event", name, payload);
  }

  if (typeof window !== "undefined" && typeof window.clarity === "function") {
    window.clarity("event", name);
  }
};

export const telemetryConfig = {
  analyticsEnabled: env.analyticsEnabled,
  clarityEnabled: env.clarityEnabled,
  gaMeasurementIdConfigured: Boolean(env.gaMeasurementId),
  clarityProjectConfigured: Boolean(env.clarityProjectId),
};
